
import { createNamespacedHelpers } from 'vuex'
export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('App/Cart')
